import { app } from '../shared';

export const fetchUserTargetingSummary = async () => {
  return app.service('user-targeting-summary').find({});
};
